import { __extends } from "tslib";
import { GetUserEndpointsRequest, GetUserEndpointsResponse } from "../models/models_1";
import { deserializeAws_restJson1GetUserEndpointsCommand, serializeAws_restJson1GetUserEndpointsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetUserEndpointsCommand = /** @class */ (function (_super) {
    __extends(GetUserEndpointsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetUserEndpointsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetUserEndpointsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetUserEndpointsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetUserEndpointsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetUserEndpointsResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetUserEndpointsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetUserEndpointsCommand(input, context);
    };
    GetUserEndpointsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetUserEndpointsCommand(output, context);
    };
    return GetUserEndpointsCommand;
}($Command));
export { GetUserEndpointsCommand };
//# sourceMappingURL=GetUserEndpointsCommand.js.map